import { useNavigate } from 'react-router-dom';

const benefits = [
  { icon: 'ri-stack-line', label: 'Große Produktauswahl', img: 'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20fashion%20items%20including%20sneakers%20hoodies%20caps%20and%20accessories%20arranged%20in%20organized%20grid%20pattern%20on%20warm%20sand%20colored%20texture%20surface%2C%20soft%20natural%20daylight%2C%20clean%20minimalist%20editorial%20composition%2C%20warm%20earthy%20tones&width=400&height=300&seq=auth-produkte&orientation=landscape' },
  { icon: 'ri-search-line', label: 'Einfache Suche', img: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20laptop%20screen%20displaying%20organized%20product%20grid%20interface%20with%20search%20bar%20on%20a%20wooden%20desk%20with%20warm%20ambient%20lighting%2C%20clean%20modern%20workspace%20aesthetic%2C%20soft%20focus%20background%2C%20warm%20neutral%20tones&width=400&height=300&seq=auth-suche&orientation=landscape' },
  { icon: 'ri-scales-line', label: 'Preisvergleich', img: 'https://readdy.ai/api/search-image?query=Clean%20still%20life%20of%20two%20product%20price%20tags%20side%20by%20side%20on%20warm%20linen%20fabric%20background%20with%20small%20potted%20succulent%2C%20soft%20diffused%20daylight%2C%20minimal%20comparison%20concept%2C%20warm%20cream%20and%20earthy%20tones&width=400&height=300&seq=auth-preis&orientation=landscape' },
  { icon: 'ri-store-2-line', label: 'Verkäuferübersicht', img: 'https://readdy.ai/api/search-image?query=Elegant%20organized%20desk%20with%20multiple%20seller%20profile%20cards%20arranged%20in%20a%20grid%20on%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20aesthetic%2C%20warm%20neutral%20palette%20with%20sand%20tones&width=400&height=300&seq=auth-verkaeufer&orientation=landscape' },
  { icon: 'ri-shield-check-line', label: 'QC Informationen', img: 'https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20a%20premium%20product%20tag%20with%20quality%20checkmark%20next%20to%20fabric%20swatches%20on%20warm%20oak%20surface%2C%20soft%20studio%20lighting%2C%20professional%20quality%20control%20concept%2C%20clean%20minimal%20composition%20with%20warm%20neutral%20tones&width=400&height=300&seq=auth-qc&orientation=landscape' },
  { icon: 'ri-user-smile-line', label: 'Anfängerfreundlich', img: 'https://readdy.ai/api/search-image?query=Friendly%20welcoming%20desk%20setup%20with%20open%20notebook%20handwritten%20welcome%20note%20coffee%20cup%20and%20small%20plant%20on%20warm%20beige%20surface%2C%20soft%20morning%20light%2C%20cozy%20inviting%20atmosphere%2C%20warm%20cream%20and%20sand%20tones&width=400&height=300&seq=auth-anfaenger&orientation=landscape' },
];

export default function Authority() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-[1440px] mx-auto">
        <div className="bg-foreground-950 rounded-3xl overflow-hidden relative">
          <div className="relative z-10 px-8 md:px-16 py-16 md:py-24 text-center">
            <p className="text-xs tracking-widest uppercase text-accent-400 font-medium mb-4">
              Warum OOPBUY Spreadsheet
            </p>

            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4 max-w-3xl mx-auto">
              Die umfassendste OOPBUY Ressource im deutschsprachigen Raum
            </h2>

            <p className="text-sm md:text-base text-secondary-400 max-w-xl mx-auto mb-12">
              Tausende Käufer vertrauen auf das OOPBUY Spreadsheet für ihre täglichen Produktentdeckungen und Preisvergleiche.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-16">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="bg-white hover:bg-secondary-100 text-foreground-950 px-7 py-3 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap"
              >
                oopbuy spreadsheet
              </a>
              <button
                onClick={() => { navigate('/artikel/oopbuy-spreadsheet-guide'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                className="border border-white/30 hover:border-white/60 text-white px-7 py-3 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Guide lesen
              </button>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {benefits.map((benefit) => (
                <div
                  key={benefit.label}
                  className="bg-white/5 hover:bg-white/10 rounded-xl overflow-hidden transition-all duration-200 group cursor-default"
                >
                  <div className="aspect-[4/3] overflow-hidden relative">
                    <img
                      src={benefit.img}
                      alt={benefit.label}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
                  </div>
                  <div className="p-3 md:p-4">
                    <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                      <i className={`${benefit.icon} text-base text-accent-400`} />
                    </div>
                    <p className="text-white/80 text-xs md:text-sm text-center whitespace-nowrap">{benefit.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 select-none pointer-events-none opacity-[0.03]">
            <p className="text-white text-[12rem] md:text-[16rem] font-heading font-bold leading-none text-center">
              OOPBUY
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}